import { useState, useEffect } from 'react'
import { branchService } from '@/modules/branches/services/branchService'
import type { BranchOffice } from '@/modules/branches/types'

/**
 * Loads all branch offices for the current company.
 * Used by client form, add points, redeem points, etc.
 */
export function useBranchOffices() {
  const [branches, setBranches] = useState<BranchOffice[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const data = await branchService.getAll()
        setBranches(data)
      } catch {
        // Silently fail — forms will just have empty dropdown
      } finally {
        setIsLoading(false)
      }
    }
    fetchBranches()
  }, [])

  return { branches, isLoading }
}
